/* eslint-disable react-refresh/only-export-components */
import { fetchItemSelectOptions } from '@/api/options/item'
import { ItemSelectOption } from '@/api/options/item.schema'
import { useSuspenseQuery } from '@tanstack/react-query'
import { createContext, useContext, ReactNode, useMemo } from 'react'

type TranslationContextType = {
  translateErrorMessage: (message: string) => string
  items: ItemSelectOption[]
}

const TranslationContext = createContext<TranslationContextType | undefined>(
  undefined
)

export function TranslationProvider({ children }: { children: ReactNode }) {
  const itemOptions = useSuspenseQuery(fetchItemSelectOptions())

  const translateErrorMessage = useMemo(() => {
    return (message: string): string => {
      // Pattern: "Quantity insufficient for item id: 5" → "Quantity insufficient for item: 2HD05A"
      const pattern = /item id:\s*(\d+)/gi
      return message.replace(pattern, (match, itemId) => {
        const item = itemOptions.data.find((i) => i.id === parseInt(itemId))
        return item ? `item: ${item.code}` : match
      })
    }
  }, [itemOptions.data])

  return (
    <TranslationContext.Provider
      value={{ translateErrorMessage, items: itemOptions.data }}
    >
      {children}
    </TranslationContext.Provider>
  )
}

export function useTranslation() {
  const context = useContext(TranslationContext)
  if (!context) {
    throw new Error('useTranslation must be used within TranslationProvider')
  }
  return context
}
